import { themeColor } from '../../utils/themeColor';

export const BROKER_BRAND = {
  coinbase: {
    logoSrc: '/brokers/coinbase.webp',
    color: '#0052ff',
    shortName: 'CB',
    tone: 'coinbase',
  },
  alpaca: {
    logoSrc: '/brokers/alpaca.png',
    color: '#fcd605',
    shortName: 'A',
    tone: 'alpaca',
  },
  ibkr: {
    logoSrc: '/brokers/ibkr.png',
    color: '#b91c1c',
    shortName: 'IB',
    tone: 'ibkr',
  },
  ninjatrader: {
    logoSrc: '/brokers/ninjatrader.jpg',
    color: '#2563eb',
    shortName: 'NT',
    tone: 'ninjatrader',
  },
};

/*
 * Brokerages linked through SnapTrade (Robinhood, Schwab, Webull…) bring their
 * own logo with the account list. registerBrokerBrands adds them here so every
 * place that shows a broker logo or color picks them up.
 */
const LINKED_BRAND_COLORS = {
  robinhood: '#00c805',
  'charles schwab': '#00a0df',
  schwab: '#00a0df',
  webull: '#2a6ff4',
  fidelity: '#368727',
  'e*trade': '#6633cc',
  etrade: '#6633cc',
  vanguard: '#96151d',
  public: '#111827',
  tastytrade: '#e8442e',
};
const linkedBrandKeys = [];

export function registerBrokerBrands(clients = []) {
  (clients || []).forEach((c) => {
    if (!c?.logoUrl || !String(c.dataSeriesName || '').startsWith('SNAPTRADE|')) return;
    const institution = String(c.broker || '').trim();
    const key = institution.toLowerCase();
    if (!key || BROKER_BRAND[key]) return;
    BROKER_BRAND[key] = {
      logoSrc: c.logoUrl,
      color: LINKED_BRAND_COLORS[key] || themeColor('#6366f1'),
      shortName: institution.charAt(0).toUpperCase(),
      tone: 'snaptrade',
    };
    linkedBrandKeys.push(key);
  });
}

const FALLBACK_COLORS = ['#5b8def', '#3ecf8e', '#e8945a', '#ef6b6b', '#984ea3', '#76b900'];

export function resolveBrokerKey(name, broker) {
  const source = `${broker || ''} ${name || ''}`.toLowerCase();
  if (source.includes('coinbase')) return 'coinbase';
  if (source.includes('alpaca')) return 'alpaca';
  if (source.includes('interactive') || source.includes('ibkr')) return 'ibkr';
  if (source.includes('ninja')) return 'ninjatrader';
  const linked = linkedBrandKeys.find((k) => source.includes(k));
  if (linked) return linked;
  return null;
}

export function getSeriesColor(name, broker, index = 0) {
  const key = resolveBrokerKey(name, broker);
  if (key && BROKER_BRAND[key]) return BROKER_BRAND[key].color;

  const lower = String(name || '').toLowerCase();
  if (lower.includes('master multi')) return '#5C4033';
  if (lower.includes('vector capital')) return '#2962ff';
  if (lower.includes('spy') || lower.includes('s&p')) return '#e41a1c';
  if (lower.includes('qqq') || lower.includes('nasdaq')) return '#ff7f00';
  if (lower.includes('ief') || lower.includes('treasury')) return '#4daf4a';
  if (lower.includes('gld') || lower.includes('gold')) return '#ffd700';

  return FALLBACK_COLORS[index % FALLBACK_COLORS.length];
}
